import store from "@/src/store/index.js";

export function mapAttributeSlugsToIds(objectSlug, attributeSlugs) {
  const attributes =
    store.getters["objects/getAttributesBySlugOrId"](objectSlug);

  const slugToIdMap = {};
  attributeSlugs.forEach((slug) => {
    const attr = attributes.find((a) => a.slug === slug);
    if (attr) {
      slugToIdMap[slug] = attr.id;
    }
  });

  return slugToIdMap;
}

export function mapAttributeIdsToSlugs(objectSlug, attributeIds) {
  const attributes =
    store.getters["objects/getAttributesBySlugOrId"](objectSlug);

  const idToSlugMap = {};
  attributeIds.forEach((id) => {
    const attr = attributes.find((a) => a.id === id);
    if (attr) {
      idToSlugMap[id] = attr.slug;
    }
  });

  return idToSlugMap;
}

export function getCurrentUserId() {
  try {
    const userId = localStorage.getItem("userId");
    return userId ? parseInt(userId, 10) : null;
  } catch (error) {
    console.error("An error occurred while getting current User ID: ", error);
  }
}

export function canPerformActionOnEntity(resourceSlug, action, entityData) {
  const policies = getUserPolicies();
  const resourceLower = resourceSlug.toLowerCase();
  const actionUpper = action.toUpperCase();

  const objects = store.state.objects?.objects || [];
  const matchingObject = objects.find((obj) => obj.slug === resourceLower);
  const resourceId = matchingObject?.id;

  const policy = policies.find(
    (p) =>
      p.action.toUpperCase() === actionUpper &&
      (p.resource.toLowerCase() === resourceLower ||
        (resourceId && p.resource === resourceId)),
  );

  if (!policy) {
    return { allowed: false, reason: "No policy found for this action" };
  }

  const scope = policy.scope;
  if (scope === "ALL_RECORDS") {
    return { allowed: true };
  }

  if (scope === "NONE_OF_THE_RECORDS") {
    return {
      allowed: false,
      reason: "You don't have permission to perform this action",
    };
  }

  if (scope === "CONDITIONAL") {
    return { allowed: true };
  }

  return { allowed: false, reason: "Unknown permission scope" };
}

function getUserPolicies() {
  try {
    return store.state.rbac?.userPolicies || [];
  } catch (e) {
    console.error("Error getting user policies from store:", e);
    return [];
  }
}

export function getResourcePermissions(resourceSlug) {
  const policies = getUserPolicies();
  const resourceLower = resourceSlug.toLowerCase();

  const viewPolicy = policies.find(
    (p) =>
      p.resource.toLowerCase() === resourceLower &&
      p.action.toUpperCase() === "VIEW",
  );

  const editPolicy = policies.find(
    (p) =>
      p.resource.toLowerCase() === resourceLower &&
      p.action.toUpperCase() === "EDIT",
  );

  const deletePolicy = policies.find(
    (p) =>
      p.resource.toLowerCase() === resourceLower &&
      p.action.toUpperCase() === "DELETE",
  );

  return {
    canView: viewPolicy && viewPolicy.scope !== "NONE_OF_THE_RECORDS",
    canEdit: editPolicy && editPolicy.scope !== "NONE_OF_THE_RECORDS",
    canDelete: deletePolicy && deletePolicy.scope !== "NONE_OF_THE_RECORDS",
    viewScope: viewPolicy?.scope,
    editScope: editPolicy?.scope,
    deleteScope: deletePolicy?.scope,
  };
}
